/**
 * Variant Presentation Overrides (Theme + PageFly)
 * - Renames option labels (Color->Finish, Weight->Door Weight, Length->Track Length)
 * - Maps option values to friendlier text (e.g., XL150 -> 150 kg / 330 lb)
 * - Works for:
 *   * Dawn/Shopify theme variant pickers (selects)
 *   * PageFly variant selects (select.pf-variant-select)
 * - Re-applies on variant changes and DOM mutations so template overrides won't wipe customizations.
 */
(function () {
  if (window.__VARIANTS_PRESENTATION__) return;
  window.__VARIANTS_PRESENTATION__ = true;

  var LOG_PREFIX = '[VariantsPresentation]';
  function log(){ try{ console.debug.apply(console, [LOG_PREFIX].concat([].slice.call(arguments))); } catch(_){} }
  function t(s){ return (s || '').replace(/\s+/g, ' ').trim(); }

  // Label rename mapping
  var LABEL_MAP = {
    'Color': 'Finish',
    'Weight': 'Door Weight',
    'Length': 'Track Length'
  };

  // Value presentation mapping
  var COLOR_VALUE_MAP = {
    'Clear Anodized': '150 / 628 - Clear Anodized',
    'Similar to Stainless Steel': '113 / 107 - Similar to Stainless Steel',
    'Black Anodized': '109 / 711 - Black Anodized'
  };

  var WEIGHT_VALUE_MAP = {
    'XL150': '150 kg / 330 lb',
    'XL120': '120 kg / 264 lb',
    'L80':   '80 kg / 176 lb'
  };

  function renameAssociatedLabelForSelect(selectEl) {
    if (!selectEl) return;
    // 1) Associated label by "for" attribute
    var id = selectEl.id;
    if (id) {
      var lab = document.querySelector('label[for="' + CSS.escape(id) + '"]');
      if (lab) {
        var txt = t(lab.textContent);
        if (LABEL_MAP[txt]) {
          if (lab.firstChild && lab.childNodes.length === 1) lab.firstChild.nodeValue = LABEL_MAP[txt];
          else lab.textContent = LABEL_MAP[txt];
          return;
        }
      }
    }
    // 2) Nearest label sibling within typical wrappers
    var wrap = selectEl.closest('.product-form__input, .product__info-container, .pf-variant-label') || selectEl.parentElement;
    if (wrap) {
      var lab2 = wrap.querySelector('label');
      if (lab2) {
        var txt2 = t(lab2.textContent);
        if (LABEL_MAP[txt2]) {
          if (lab2.firstChild && lab2.childNodes.length === 1) lab2.firstChild.nodeValue = LABEL_MAP[txt2];
          else lab2.textContent = LABEL_MAP[txt2];
        }
      }
    }
  }

  function renameAllLabelsScope(scope) {
    scope = scope || document;
    // Theme labels
    var labs = scope.querySelectorAll('label');
    labs.forEach(function(l){
      var txt = t(l.textContent);
      if (LABEL_MAP[txt]) {
        if (l.firstChild && l.childNodes.length === 1) l.firstChild.nodeValue = LABEL_MAP[txt];
        else l.textContent = LABEL_MAP[txt];
      }
    });
    // PageFly labels (redundant safety)
    var pfLabs = scope.querySelectorAll('label.pf-variant-label,[data-pf-type="OptionLabel"]');
    pfLabs.forEach(function(l){
      var txt = t(l.textContent);
      if (LABEL_MAP[txt]) {
        if (l.firstChild && l.childNodes.length === 1) l.firstChild.nodeValue = LABEL_MAP[txt];
        else l.textContent = LABEL_MAP[txt];
      }
    });
  }

  function mapSelectOptions(select) {
    if (!select || select.tagName !== 'SELECT') return;

    // Determine option name
    var optName =
      select.getAttribute('data-option-name') ||
      (function() {
        // Try to infer from name="options[Name]"
        var nm = select.getAttribute('name') || '';
        var m = nm.match(/^options\[(.+?)\]$/);
        if (m) return m[1];
        // Fallback: label text near select
        var labelTxt = '';
        var id = select.id;
        if (id) {
          var lab = document.querySelector('label[for="' + CSS.escape(id) + '"]');
          if (lab) labelTxt = t(lab.textContent);
        }
        if (!labelTxt) {
          var wrap = select.closest('.product-form__input, .product__info-container, .bold_option, .bold-options__option') || select.parentElement;
          if (wrap) {
            var l2 = wrap.querySelector('label, .bold_option_title');
            if (l2) labelTxt = t(l2.textContent);
          }
        }
        return labelTxt;
      })() || '';

    // Normalize HTML entities
    optName = optName.replace(/&quot;|"/g, '"');

    // Select mapping
    var mapping = null;
    if (optName === 'Color' || optName === 'Finish') mapping = COLOR_VALUE_MAP;
    if (optName === 'Weight' || optName === 'Door Weight') mapping = WEIGHT_VALUE_MAP;

    if (!mapping) return;

    var changed = false;
    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var rawText = t(opt.text || opt.label || '');
      if (mapping[rawText]) {
        var newText = mapping[rawText];
        if (newText && newText !== opt.text) {
          opt.text = newText;
          changed = true;
        }
      }
    }
    if (changed) {
      try {
        var ev = new Event('change', { bubbles: true });
        select.dispatchEvent(ev);
      } catch(_) {}
    }
    // Also rename its label if needed
    renameAssociatedLabelForSelect(select);
  }

  function applyAll(scope) {
    scope = scope || document;
    // Rename labels first
    renameAllLabelsScope(scope);

    // Find all relevant selects
    var selects = scope.querySelectorAll([
      // Theme/Dawn selectors
      '.product-form__input select',
      'variant-selects select',
      'select[name^="options["]',
      // PageFly
      'select.pf-variant-select'
    ].join(','));

    selects.forEach(mapSelectOptions);
  }

  function wire() {
    // On any select change under product forms
    document.addEventListener('change', function(e){
      var tEl = e.target;
      if (!tEl || !tEl.matches) return;
      if (tEl.matches('select[name^="options["], .product-form__input select, variant-selects select, select.pf-variant-select')) {
        mapSelectOptions(tEl);
        // Re-ensure labels in the vicinity
        renameAssociatedLabelForSelect(tEl);
      }
    });

    // Shopify pub/sub (Dawn)
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, function() {
          setTimeout(applyAll, 0);
        });
      }
    } catch(_) {}

    // Custom events some themes/PageFly emit
    document.addEventListener('variant:changed', function(){ setTimeout(applyAll, 100); });

    // Shopify theme editor section reloads
    document.addEventListener('shopify:section:load', function(e){
      var tgt = (e && e.target) || document;
      setTimeout(function(){ applyAll(tgt); }, 50);
    });

    // Mutation observer for dynamic DOM (PageFly + Theme async renders)
    try {
      var root = document.querySelector('product-info') || document.getElementById('__pf') || document.body || document.documentElement;
      var debounce = null;
      var mo = new MutationObserver(function(){
        clearTimeout(debounce);
        debounce = setTimeout(function(){ applyAll(root); }, 150);
      });
      mo.observe(root, { childList: true, subtree: true });
    } catch(_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      applyAll();
      wire();
      log('Initialized (DOMContentLoaded).');
    });
  } else {
    applyAll();
    wire();
    log('Initialized (ready).');
  }
})();
/* -- Add radio/button picker support to preserve labels/values even if template changes -- */
(function () {
  if (window.__VARIANTS_PRESENTATION_RADIOS__) return;
  window.__VARIANTS_PRESENTATION_RADIOS__ = true;

  var LABEL_MAP_RAD = {
    'Color': 'Finish',
    'Weight': 'Door Weight',
    'Length': 'Track Length'
  };

  var COLOR_VALUE_MAP_RAD = {
    'Clear Anodized': '150 / 628 - Clear Anodized',
    'Similar to Stainless Steel': '113 / 107 - Similar to Stainless Steel',
    'Black Anodized': '109 / 711 - Black Anodized'
  };

  var WEIGHT_VALUE_MAP_RAD = {
    'XL150': '150 kg / 330 lb',
    'XL120': '120 kg / 264 lb',
    'L80':   '80 kg / 176 lb'
  };

  function trim(s){ return (s || '').replace(/\s+/g, ' ').trim(); }
  function setText(el, txt){
    if (!el) return;
    if (el.firstChild && el.childNodes.length === 1 && el.firstChild.nodeType === 3) {
      el.firstChild.nodeValue = txt;
    } else {
      el.textContent = txt;
    }
  }

  function renameLegends(scope){
    scope = scope || document;
    var legends = scope.querySelectorAll('fieldset legend, .product-form__input legend');
    legends.forEach(function(leg){
      var txt = trim(leg.textContent);
      if (LABEL_MAP_RAD[txt]) setText(leg, LABEL_MAP_RAD[txt]);
    });
  }

  function radiosForName(name){
    // Theme-style names: options[Name]
    var list = Array.from(document.querySelectorAll('input[type="radio"][name="options['+name+']"]'));
    // Also directly named radio groups (rare)
    list = list.concat(Array.from(document.querySelectorAll('input[type="radio"][name="'+name+'"]')));
    return list;
  }

  function mapRadios(name, mapping){
    var radios = radiosForName(name);
    // Handle renamed groups too (e.g., Weight -> Door Weight, Color -> Finish)
    if (!radios.length) {
      if (name === 'Weight') radios = radiosForName('Door Weight');
      if (name === 'Color')  radios = radiosForName('Finish');
    }
    radios.forEach(function(r){
      var raw = trim(r.getAttribute('data-value') || r.value || '');
      var label = document.querySelector('label[for="'+CSS.escape(r.id)+'"]');
      if (!label) return;
      var node = label.querySelector('.swatch__label, .value, span, strong') || label;
      if (mapping && mapping[raw]) setText(node, mapping[raw]);
    });
  }

  function applyRadios(scope){
    renameLegends(scope);
    mapRadios('Color', COLOR_VALUE_MAP_RAD);
    mapRadios('Weight', WEIGHT_VALUE_MAP_RAD);
    // Length: legend rename only; values usually numeric like 96"
  }

  function wire(){
    document.addEventListener('change', function(e){
      if (e && e.target && e.target.matches && e.target.matches('input[type="radio"][name^="options["], input[type="radio"]')) {
        applyRadios(document);
      }
    });
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, function(){ setTimeout(applyRadios, 0); });
      }
    } catch(_) {}
    document.addEventListener('variant:changed', function(){ setTimeout(applyRadios, 50); });
    try {
      var root = document.querySelector('product-info') || document.getElementById('__pf') || document.body || document.documentElement;
      var t=null;
      var mo = new MutationObserver(function(){ clearTimeout(t); t = setTimeout(applyRadios, 120); });
      mo.observe(root, { childList: true, subtree: true });
    } catch(_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ applyRadios(); wire(); });
  } else {
    applyRadios(); wire();
  }
})();
/* -- Handed visibility controller (Theme + PageFly + Bold) -- */
(function () {
  if (window.__HAND_VISIBILITY_CONTROLLER__) return;
  window.__HAND_VISIBILITY_CONTROLLER__ = true;

  function trim(s){ return (s || '').replace(/\s+/g, ' ').trim(); }

  function getDoorWeightText() {
    // 1) PageFly select
    let sel = document.querySelector('select.pf-variant-select[data-option-name="Door Weight"], select.pf-variant-select[data-option-name="Weight"]');
    if (sel) {
      const idx = sel.selectedIndex;
      const txt = sel.options?.[idx]?.text || sel.value || '';
      if (txt) return trim(txt);
    }
    // 2) Theme selects with labels/legends
    const variantSelects = document.querySelectorAll('.product-form__input select, .variant-select select, select[name^="options["]');
    for (const s of variantSelects) {
      const grp = s.closest('.product-form__input, fieldset') || s.parentElement;
      const lab = grp?.querySelector('label, legend');
      const ltxt = (lab?.textContent || '').toUpperCase();
      if (ltxt.includes('DOOR WEIGHT') || ltxt === 'WEIGHT' || ltxt.includes('WEIGHT')) {
        const idx = s.selectedIndex;
        const txt = s.options?.[idx]?.text || s.value || '';
        if (txt) return trim(txt);
      }
    }
    // 3) Theme radios (button picker)
    let radios = document.querySelectorAll('input[type="radio"][name="Door Weight"], input[type="radio"][name="Weight"]');
    if (!radios.length) {
      document.querySelectorAll('fieldset, .product-form__input').forEach(fs => {
        const lg = fs.querySelector('legend, label');
        const t = (lg?.textContent || '').toUpperCase();
        if (t.includes('DOOR WEIGHT') || t === 'WEIGHT' || t.includes('WEIGHT')) {
          const r = fs.querySelectorAll('input[type="radio"][name^="options["]');
          if (r.length) radios = r;
        }
      });
    }
    if (radios.length) {
      let val = '';
      radios.forEach(r => {
        if (r.checked) {
          val = r.value || r.getAttribute('data-value') || '';
          if (!val) {
            try {
              const lab = document.querySelector('label[for="' + r.id + '"]');
              const node = lab && (lab.querySelector('.swatch__label, .value, span, strong') || lab);
              const txt = node ? node.textContent : '';
              if (txt) val = txt;
            } catch(_) {}
          }
        }
      });
      return trim(val);
    }
    return '';
  }

  function findHandedContainers() {
    const out = [];
    const containers = document.querySelectorAll('.bold_option, .bold-options__option');
    containers.forEach(c => {
      const label = c.querySelector('.bold_option_title, label, .bold_option_value_title, .bold_option_product_title');
      const t = (label?.textContent || '').toUpperCase();
      if (t.includes('HANDED')) out.push(c);
    });
    return out;
  }

  function setDisabledForInputs(container, disabled) {
    if (!container) return;
    const inputs = container.querySelectorAll('select, input, textarea, button');
    inputs.forEach(el => {
      el.disabled = !!disabled;
      if (disabled) {
        el.setAttribute('aria-disabled', 'true');
        if (el.tagName === 'SELECT') el.selectedIndex = 0;
        if (el.type === 'radio' || el.type === 'checkbox') el.checked = false;
      } else {
        el.removeAttribute('aria-disabled');
      }
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch(_) {}
    });
  }

  function decideShowFromWeight(txt) {
    const U = (txt || '').toUpperCase();
    const is120 = /\b(?:XL)?120\b/.test(U) || /\bM120\b/.test(U) || /120\s*KG|264\s*LB/.test(U);
    return !!is120; // show only for 120 kg / 264 lb
  }

  function applyHandedVisibility() {
    const txt = getDoorWeightText();
    const show = decideShowFromWeight(txt);
    const containers = findHandedContainers();
    containers.forEach(c => {
      if (show) {
        c.style.display = '';
        c.classList.remove('bold-options--disabled', 'disabled');
        c.style.opacity = '';
        c.style.pointerEvents = '';
        setDisabledForInputs(c, false);
      } else {
        c.style.display = 'none';
        setDisabledForInputs(c, true);
      }
    });
  }

  function wire() {
    document.addEventListener('change', function(e) {
      const t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('select.pf-variant-select, .product-form__input select, .variant-select select, select[name^="options["], input[type="radio"][name^="options["], input[type="radio"][name="Door Weight"], input[type="radio"][name="Weight"]')) {
        setTimeout(applyHandedVisibility, 0);
      }
    });
    document.addEventListener('variant:changed', function(){ setTimeout(applyHandedVisibility, 50); });
    document.addEventListener('BOLD_OPTIONS_update', function(){ setTimeout(applyHandedVisibility, 50); });
    try {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, function(){ setTimeout(applyHandedVisibility, 0); });
      }
    } catch(_) {}

    try {
      const root = document.querySelector('.bold_options') || document.querySelector('product-info') || document.getElementById('__pf') || document.body || document.documentElement;
      let tmr = null;
      const mo = new MutationObserver(() => { clearTimeout(tmr); tmr = setTimeout(applyHandedVisibility, 120); });
      mo.observe(root, { childList: true, subtree: true });
    } catch(_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ applyHandedVisibility(); wire(); });
  } else {
    applyHandedVisibility(); wire();
  }
})();